import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import CheckboxItem from "../../../components/print/workDiary/CheckboxItem";
const { Title } = Typography;

const NonServiceReasons = () => {
  const intl = useIntl();
  return (
    <div className="borderedSection" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.nonServiceReasons",
        })}
      </Title>
      <div className="spacerContainer">
        <div>
          <CheckboxItem
            name="middleOfWeekReason"
            style={{ lineHeight: "10px" }}
          />
          <CheckboxItem
            name="terminationReason"
            style={{ lineHeight: "10px" }}
          />
          <CheckboxItem name="demise" style={{ lineHeight: "10px" }} />
          <CheckboxItem name="hospitalization" style={{ lineHeight: "10px" }} />
          <CheckboxItem name="absence" style={{ lineHeight: "10px" }} />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <CheckboxItem name="other" style={{ lineHeight: "10px" }} />
            <div style={{ width: "90%", borderBottom: "1px solid" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NonServiceReasons;
